/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable semi */
/* eslint-disable no-unsafe-finally */
/* eslint-disable indent */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable quotes */

'use strict';

function NoVideoInputDevicesError() {
  this.name = 'NoVideoInputDevicesError';
  this.message = 'No video input devices found';
}
NoVideoInputDevicesError.prototype = new Error();

module.exports = {
  NoVideoInputDevicesError: NoVideoInputDevicesError
};